import { createTracker } from '~~/analytics/client-js';

export const IMPRESSION = 'display';
export const CLICK = 'click';
export const TYPE_ENTITY = 'entity';
export const TYPE_RICH = 'rich';
export const TYPE_WIDGET = 'widget';
export const PAGE_SERP = 'serp';

const context = [
  'abTests',
  'mainCookie',
  'requestID',
];

const sentEvents = new Set();

/**
 * Sends impression event for rich content. If `once` is set to true,
 * the event will only be tracked once even if the function is called
 * multiple times. The "de-duplication" is done by combining the name, page and type
 * parameters, so unique combinations of the three are considered.
 *
 * @param {Object} options tracking options: { name, page, type }
 * @returns {Function}
 */
export const trackImpression = ({ name, page, type, once = false, triggerUrl = '' }) => {
  const serialised = [page, type, name, triggerUrl].join();

  if (once && sentEvents.has(serialised)) {
    return;
  }

  sentEvents.add(serialised);
  const track = createTracker({
    tracker: 'trackStructEvent',
    data: {
      category: `${name}_${type}`,
      action: IMPRESSION,
      label: `${page}_page`,
      property: triggerUrl,
      value: 0,
    },
    context,
  });

  track();
};

/**
 * Creates a click tracking function for rich content.
 *
 * @param {Object} options { name, type, target, property, value }
 * where `target` identifies the button/link clicked and `property/value`
 * correspond to the regular structured event parameters
 */
export const trackClick = ({ name, type, target, property = '', value = 0 }) => {
  const track = createTracker({
    tracker: 'trackStructEvent',
    data: {
      category: `${name}_${type}`,
      action: CLICK,
      label: target,
      property,
      value,
    },
    context,
  });

  return track;
};
